module.exports = __webpack_public_path__ + "img/moto-02.f161a17e.svg";